export default __webpack_public_path__ + "static/media/portfolio-image.ab0958e5.jpg";